import { Component, OnInit } from '@angular/core';
import { forkJoin, merge, Observable, of, timer } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoaderService } from 'src/app/services/loader.service';
import { WalletService } from 'src/app/services/wallet.service';
import moment from 'moment-timezone';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  totalTezzardz = 4200;
  price = 15;
  tezzardzAdopted$: Observable<number>;
  hasTezzardz$: Observable<boolean>;
  countdown$: Observable<any>;
  startDate = moment.tz('2021-08-31 20:00', 'Europe/Paris');
  hasCountdown = moment().isBefore(this.startDate);

  tezzardzToAdopt = 1;

  Math = window.Math;

  constructor(
    private walletService: WalletService,
    private loaderService: LoaderService
  ) {
    this.tezzardzAdopted$ = merge(
      of(0),
      this.walletService.getTezzardzAdopted()
    ).pipe(map((value) => (value == 0 ? 1 : value)));

    this.hasTezzardz$ = this.tezzardzAdopted$.pipe(
      map((adopted) => adopted < this.totalTezzardz)
    );

    this.countdown$ = timer(0, 1000).pipe(map((x) => this.getCountdown()));
  }

  ngOnInit(): void {}

  get tezzardString() {
    return this.tezzardzToAdopt > 1 ? 'Tezzardz' : 'Tezzardz';
  }

  adopt() {
    this.loaderService.setLoading(true);
    this.loaderService.setText('Confirm your Tezzardz...');
    if (this.walletService.hasPermission()) {
      this.onAdopt();
    } else {
      this.walletService.requestPermission().subscribe(
        (_) => {
          if (this.walletService.hasPermission()) {
            this.onAdopt();
          } else {
            // TODO: handle this case
            this.loaderService.setLoading(false);
            // show error
          }
        },
        (e) => {
          this.loaderService.setLoading(false);
        }
      );
    }
  }

  private onAdopt() {
    forkJoin({
      contract: this.walletService.getTezzardContract(),
      price: this.getPrice(this.tezzardzToAdopt),
    })
      .pipe(
        map(({ contract, price }) => {
          contract.methods
            .mint(this.tezzardzToAdopt)
            .send({
              amount: price as number,
              storageLimit: this.tezzardzToAdopt * 500,
            })
            .then(
              (op) => {
                this.loaderService.setText('Waiting for confirmation');
                op.confirmation(1).then(() => {
                  this.loaderService.showCongratulation(this.tezzardzToAdopt);
                });
              },
              (error) => {
                this.loaderService.setLoading(false);
              }
            );
        })
      )
      .subscribe();
  }

  private getPrice(tezzardz: number) {
    return of(tezzardz * this.price);
  }

  private getCountdown() {
    const diff = moment.duration(moment(this.startDate).diff(moment()));
    const days = diff.days();
    const hours = diff.hours();
    const minutes = diff.minutes();
    const seconds = diff.seconds();

    this.hasCountdown = moment().isBefore(this.startDate);
    return {
      days: days < 0 ? 0 : days,
      hours: hours < 0 ? 0 : hours,
      minutes: minutes < 0 ? 0 : minutes,
      seconds: seconds < 0 ? 0 : seconds,
    };
  }
}
